module.exports = __webpack_public_path__ + "aw.svg?a7669807f4cc4b5e844282af3eb036e7";